<div class="primary">
  <iron-icon icon="clear" class="back-to-cases" (click)="goBackToCases()"></iron-icon>
  <span [innerHTML]="primaryText|unsanitizeHtml"></span>
</div>
<div class="secondary" *ngIf="secondaryText">
    <iron-icon icon="chevron-left" routerLink="{{secondaryLink}}"></iron-icon>
    <span [innerHTML]="secondaryText|unsanitizeHtml"></span>
</div>